import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import HintsHeader from './HintsHeader';
import HintsCSAddForm from './HintsCSAddForm';
import HintsNoData from './HintsNoData';
import { HintCSList as HintsList } from './HintsList';
import {
  removeSingleConcurrentStudy,
  removeConcurrentStudy,
  getConcurrentStudies,
  inviteCS,
  jobProfileRemindCS,
} from '../../../../../services/apps/JobProfileService';
import DeleteSpecCSConfirmModal from './CSDeleteConfirmModal';
import { Loading } from '../../../../../components/Loading';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { growlErrors, growlActionSuccess } from '../../../../../utils/NotificationUtil';
import { withAccount } from '../../../../../components/AccountContext';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import { intlShape } from '../../../../../components/prop-types';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

class HintsCS extends Component {
  static previewCSURL(assessment) {
    if (assessment) {
      window.open(assessment.startUrl, '_blank');
    } else {
      console.warn('null value');
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      isShowAddForm: false,
      selectedCS: null,
      searching: false,
      loadingCS: false,
      concurrentStudies: [],
    };

    this.toggleShowAddForm = this.toggleShowAddForm.bind(this);
    this.handleInviteCSRespondent = this.handleInviteCSRespondent.bind(this);
    this.handleHints = this.handleHints.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSearchRespondent = this.handleSearchRespondent.bind(this);
    this.handleRemindCSRespondent = this.handleRemindCSRespondent.bind(this);
    this.processDeleteAllCS = this.processDeleteAllCS.bind(this);

    this.deleteCS = this.deleteCS.bind(this);
    this.cancelDeletingCS = this.cancelDeletingCS.bind(this);
    this.processDeletingCS = this.processDeletingCS.bind(this);
  }

  componentDidMount() {
    this.fetchJobCS();
  }

  async fetchJobCS() {
    const { match, growl, currentAccount } = this.props;
    const { jobProfileId } = match.params;
    this.setState({
      loadingCS: true,
    });
    try {
      const data = await getConcurrentStudies({
        accountId: currentAccount,
        jobProfileId,
      });
      this.setState({
        loadingCS: false,
        concurrentStudies: data,
      });
    } catch (error) {
      growlErrors(growl, error);
      this.setState({
        loadingCS: false,
      });
    }
  }

  async handleInviteCSRespondent(respondentId) {
    const {
      match,
      intl: { formatMessage },
      currentAccount,
      growl,
    } = this.props;
    const { jobProfileId } = match.params;
    try {
      await inviteCS({
        jobProfileId,
        respondentId,
        accountId: currentAccount,
      });
      this.fetchJobCS();
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (err) {
      growlErrors(growl, err);
    }
  }

  async handleRemindCSRespondent(respondentId) {
    const {
      currentAccount, match, intl, growl,
    } = this.props;
    const { formatMessage } = intl;
    await jobProfileRemindCS({
      jobProfileId: match.params.jobProfileId,
      respondentId,
      accountId: currentAccount,
    })
      .then((response) => {
        growlActionSuccess(growl, formatMessage(messages.successNoti));
        Promise.resolve(response);
      })
      .catch((graphqlResponse) => {
        growlErrors(growl, graphqlResponse);
      });
  }

  async processDeleteAllCS(formValues) {
    const { match, growl, currentAccount } = this.props;
    const { jobProfileId } = match.params ? match.params : null;
    const { keepData, confirmation_code, re_confirmation_code } = formValues;
    if (jobProfileId && confirmation_code === re_confirmation_code) {
      try {
        const keepDataBool = keepData || false;
        await removeConcurrentStudy({
          jobProfileId,
          keepDataBool,
          accountId: currentAccount,
        });
        window.location.reload();
      } catch (error) {
        growlErrors(growl, error);
      }
    }
  }

  toggleShowAddForm() {
    const { isShowAddForm } = this.state;
    this.setState({ isShowAddForm: !isShowAddForm });
  }

  async handleHints() {
    const {
      onHints, growl, intl,
      isShowHint,
    } = this.props;
    const { formatMessage } = intl;
    const isShowHintNew = !isShowHint;
    try {
      await onHints(isShowHintNew);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (error) {
      growlErrors(growl, error);
    }
  }

  async handleAdd(formValues) {
    const { growl, onAdd } = this.props;
    try {
      await onAdd(formValues);
      this.toggleShowAddForm();
      this.fetchJobCS();
    } catch (error) {
      growlErrors(growl, error);
    }
  }

  async handleToggle(csId) {
    const { onHints, onToggle } = this.props;
    await onHints(true);
    await onToggle(csId);
  }

  async handleSearchRespondent(searchTerm) {
    const { onSearch } = this.props;
    this.setState({ searching: true });
    await onSearch(searchTerm);
    this.setState({ searching: false });
  }

  deleteCS(csId) {
    this.setState({
      selectedCS: csId,
    });
  }

  cancelDeletingCS() {
    this.setState({
      selectedCS: null,
    });
  }

  async processDeletingCS(formValues) {
    const { growl, currentAccount } = this.props;
    const { selectedCS } = this.state;
    const { keepData, confirmation_code, re_confirmation_code } = formValues;
    if (selectedCS && confirmation_code === re_confirmation_code) {
      try {
        await removeSingleConcurrentStudy({
          concurrentStudyId: selectedCS,
          keepData: keepData || false,
          accountId: currentAccount,
        });
        await this.fetchJobCS();
        this.setState({
          selectedCS: null,
        });
      } catch (error) {
        growlErrors(growl, error);
        this.setState({
          selectedCS: null,
        });
      }
    }
  }

  render() {
    const {
      currentAccount, jobId,
      isShowHint,
    } = this.props;
    const {
      searching, loadingCS, concurrentStudies,
      selectedCS,
    } = this.state;
    if (loadingCS) {
      return <Loading />;
    }
    const { isShowAddForm } = this.state;
    return (
      <Panel
        className="panel-CS"
        header={(
          <HintsHeader
            onShowAddForm={this.toggleShowAddForm}
            onHints={this.handleHints}
            isShow={isShowHint}
          >
            <FormattedMessage id="CS.performer.plural" defaultMessage="Top Performers" />
          </HintsHeader>
        )}
      >
        {isShowAddForm && (
          <HintsCSAddForm
            concurrentStudies={concurrentStudies}
            onAdd={this.handleAdd}
            searching={searching}
            onCancel={this.toggleShowAddForm}
            onSeachRespondent={this.handleSearchRespondent}
          />
        )}

        {(!concurrentStudies || ArrayUtil.isEmpty(concurrentStudies)) && (
          <HintsNoData onAdd={this.toggleShowAddForm}>
            <FormattedMessage id="CS.empty" defaultMessage="No Top Performers registered yet." />
          </HintsNoData>
        )}

        {concurrentStudies && (
          <HintsList
            data={concurrentStudies}
            currentAccount={currentAccount}
            onInvite={this.handleInviteCSRespondent}
            onReminder={this.handleRemindCSRespondent}
            onToggle={this.handleToggle}
            onRemove={this.deleteCS}
            previewURL={this.previewCSURL}
            jobId={jobId}
          />
        )}
        <DeleteSpecCSConfirmModal
          modalOpen={!!selectedCS}
          selectedCS={selectedCS}
          reject={this.cancelDeletingCS}
          confirm={this.processDeletingCS}
        />
      </Panel>
    );
  }
}

HintsCS.propTypes = {
  intl: intlShape.isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  onHints: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  isShowHint: PropTypes.bool.isRequired,
};

export default withGrowl(withAccount(injectIntl(HintsCS)));
